import { OrganizationCustomFieldsTypes } from "__generated__/graphql";
import { AxiosInstance } from "axios";
import { parseTypeStringToEndpoint } from "utils/organizationCustomFieldsUtils";
import { getRpcParams } from "./rpcUtils";
import RpcMethod from "./rpcMethod";

export default function deleteCustomFieldRpcService(client: AxiosInstance) {
  return {
    deleteField: (type: OrganizationCustomFieldsTypes, index: number) => client.post(`./rpc/${parseTypeStringToEndpoint(type)}`, getRpcParams(RpcMethod.CLEAR_CUSTOM_FIELD_VALUES, { field: `CustomField${index+1}` }, '1.0'))
  }
}